import React from 'react';
import { Pressable, HStack, Box, VStack, ChevronRightIcon } from 'native-base';
import { Text } from '../atoms';
import { Switch } from './Switch';
import { I18nManager } from 'react-native';
const isRTL = I18nManager.isRTL;
function TableViewSubText({ children, ...rest }) {
    return (React.createElement(Text, { color: "text.20", fontToken: "bodyBaseDefault", ...rest }, children));
}
function TableViewBase({ titleLarge, title, optionalLabel, description, children, childrenAlignCenter, icon, testIDTitle, testIDDescription, testIDOptionalLabel, isGrouped, isFirstRow, ...rest }) {
    return (React.createElement(VStack, { bg: "neutral.container", borderRadius: isGrouped ? 0 : 8, borderTopWidth: isGrouped && !isFirstRow ? 1 : 0, 
        // hack to make color 50% opacity
        borderColor: 'neutral.20', p: 4, ...rest },
        React.createElement(HStack, { alignItems: "center" },
            icon && (React.createElement(Box, { mr: 2, alignSelf: "center" }, icon)),
            React.createElement(VStack, { flex: 1 },
                React.createElement(HStack, { justifyContent: "space-between", space: 1 },
                    React.createElement(Text, { fontToken: `body${titleLarge ? 'Large' : 'Base'}Medium`, color: "text.100", testID: testIDTitle }, title),
                    !childrenAlignCenter && children),
                optionalLabel && (React.createElement(Text, { fontToken: "bodyBaseDefault", color: "text.20", testID: testIDOptionalLabel, textAlign: 'left' }, optionalLabel))),
            childrenAlignCenter && children),
        description && (React.createElement(TableViewSubText, { mt: 3, testID: testIDDescription, textAlign: "left" }, description))));
}
export function TableView({ text, testIDText, ...rest }) {
    return (React.createElement(TableViewBase, { ...rest },
        React.createElement(TableViewSubText, { testID: testIDText }, text)));
}
function TableViewLink({ onPress, label, linkIcon, testID, testIDLabel, testIDIcon, ...rest }) {
    return (React.createElement(Pressable, { onPress: onPress, testID: testID, accessibilityRole: "button" },
        React.createElement(TableViewBase, { childrenAlignCenter: !label, ...rest },
            React.createElement(HStack, { alignItems: "center" },
                label && (React.createElement(TableViewSubText, { mr: 2, testID: testIDLabel }, label)),
                linkIcon ? (linkIcon) : (React.createElement(ChevronRightIcon, { style: { transform: [{ scaleX: isRTL ? -1 : 1 }] }, size: 4, color: "interactive.text.active", testID: testIDIcon }))))));
}
function TableViewToggle({ onToggle, isChecked, label, testIDLabel, testIDSwitch, ...rest }) {
    return (React.createElement(TableViewBase, { childrenAlignCenter: true, ...rest },
        React.createElement(HStack, { alignItems: "center" },
            React.createElement(Switch, { onToggle: onToggle, isChecked: isChecked, label: label, testIDLabel: testIDLabel, testIDSwitch: testIDSwitch }))));
}
function TableViewGroupWrapper({ children, ...rest }) {
    return (React.createElement(Box, { overflow: "hidden", borderRadius: 8, ...rest }, children));
}
TableView.Link = TableViewLink;
TableView.Toggle = TableViewToggle;
TableView.GroupWrapper = TableViewGroupWrapper;
